import React, { Component } from 'react';
import { connect } from 'react-redux';
import {login, logout} from '../fm/reducers/auth'
//import {LOGO, WEBSITE_NAME} from '../config'
import {find} from '../fm/reducers/page'
import Link from '../fm/lib/Link'
import EntityAdminMenu from '../fm/admin/EntityAdminMenu'
import {Text} from '../fm/field'
class Footer extends Component {
	componentWillMount() {
		const {footer, menu, find} = this.props

		if(!menu) find('footerMenu', {collection: 'menu', query: {type:'footer'}})
		if(!footer) find('footer', {collection: 'region', query: {title: 'Subsol'}})
	}
  	render() {
	    const { isAuthenticated, menu, footer, login, logout } = this.props

		return (
			<footer id='footer'><div ref='footer' className='footer-in'>
				{footer && <EntityAdminMenu entity={footer} tag='footer'/>}
				<div className='menus'>
				{menu && 
					menu.map((menuItem, i) =>
					<div key={i} className='column'>
						<h3><Link to={menuItem.p}>{menuItem.title}</Link></h3>
						{menuItem.items &&
							<ul className="footer-menu ">
							{menuItem.items.map((submenuItem, j) =>
								<li key={j}><Link to={submenuItem.p}>{submenuItem.title}</Link></li>
							)}
							</ul>
						}
					</div>
				)}
				</div>
				<div className='kids'>
                    <div className='kido'><div className='kid'><div className='kidi'/></div></div>
                    <div className='kido'><div className='kid'><div className='kidi'/></div></div>
                    <div className='kido'><div className='kid'><div className='kidi'/></div></div>
                    <div className='kido'><div className='kid'><div className='kidi'/></div></div>
                    <div className='kido'><div className='kid'><div className='kidi'/></div></div>
                    <div className='kido'><div className='kid'><div className='kidi'/></div></div>
					{footer && <Text entity={footer} fieldName='text' value={footer.text} refreshTag='footer'/>}
				</div>
			</div>
				<div className='auth'>
				{isAuthenticated
					? <a onClick={logout}><i className='fa fa-unlock-alt'></i> Logout</a>
					: <a onClick={login}><i className='fa fa-lock'></i> Login</a>
				}
				</div>
				
			</footer>
    	);
  	}
}

function mapStateToProps(state) {
	return {
		isAuthenticated: state.auth.isAuthenticated,
		menu: (state.page['footerMenu'] && state.page['footerMenu'].data && state.page['footerMenu'].data.length>0)
			?state.page['footerMenu'].data[0].items
			:null,
		footer: (state.page['footer'] && state.page['footer'].data && state.page['footer'].data.length>0)?state.page['footer'].data[0]:null
	}
}
export default connect(mapStateToProps, {find, login, logout})(Footer);



// WEBPACK FOOTER //
// ./src/components/Footer.js